import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_UPDATE_DEV_API_KEY_STATUS_BEGIN,
  APP_SETTING_UPDATE_DEV_API_KEY_STATUS_SUCCESS,
  APP_SETTING_UPDATE_DEV_API_KEY_STATUS_FAILURE,
  APP_SETTING_UPDATE_DEV_API_KEY_STATUS_DISMISS_ERROR,
} from './constants';

export function updateDevApiKeyStatus(args = {}) {
  const { projectId, version, keyId, status } = args;
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_UPDATE_DEV_API_KEY_STATUS_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(projectId);
    const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/developer-apis/${projectId}/devApiKeys/${keyId}/status`;

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.patch(url, { status }, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_UPDATE_DEV_API_KEY_STATUS_SUCCESS,
            data: res.data,
          });
          const message =
            status === 'active'
              ? 'API Key reactivated successfully!'
              : status === 'inactive'
              ? 'API Key deactivated'
              : status === 'revoked'
              ? 'API Key revoked permanently'
              : 'Status updated successfully!';
          toast.success(message);
          resolve(res.data);
        },
        (err) => {
          const errMsg =
            err?.response?.data?.message || err?.message || 'Failed to update API key status';
          toast.error(errMsg);
          dispatch({
            type: APP_SETTING_UPDATE_DEV_API_KEY_STATUS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateDevApiKeyStatusError() {
  return {
    type: APP_SETTING_UPDATE_DEV_API_KEY_STATUS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_UPDATE_DEV_API_KEY_STATUS_BEGIN:
      return {
        ...state,
        updateDevApiKeyStatusPending: true,
        updateDevApiKeyStatusError: null,
      };

    case APP_SETTING_UPDATE_DEV_API_KEY_STATUS_SUCCESS: {
      const updatedKey = action.data;
      const devApiKeys = (state.devApiKeys || []).map((k) =>
        k._id === updatedKey._id || (k.uuid && k.uuid === updatedKey.uuid) ? updatedKey : k,
      );
      return {
        ...state,
        updateDevApiKeyStatusPending: false,
        updateDevApiKeyStatusError: null,
        devApiKeys,
      };
    }

    case APP_SETTING_UPDATE_DEV_API_KEY_STATUS_FAILURE:
      return {
        ...state,
        updateDevApiKeyStatusPending: false,
        updateDevApiKeyStatusError: action.data.error,
      };

    case APP_SETTING_UPDATE_DEV_API_KEY_STATUS_DISMISS_ERROR:
      return {
        ...state,
        updateDevApiKeyStatusError: null,
      };

    default:
      return state;
  }
}
